// extracted by mini-css-extract-plugin
export default {"container":"Message_container__dnk+J","body":"Message_body__bs7Qr","listConversation":"Message_listConversation__oNGzm","messageConversation":"Message_messageConversation__xLFmT"};